// extracted by mini-css-extract-plugin
export default {"info":"AboutInfo_info__cA9ED"};